//#region lib/TTVisual/lib/parseImageId.ts
function e(r) {
	if (URL.canParse(r)) {
		let e = new URL(r);
		return t(e.searchParams.get("url") || e.toString());
	}
	let i = n(r);
	if (i) return e(i.href);
}
function t(e) {
	return [/\/media\/(image|graphic)\/(sdl[A-Za-z0-9%_-]+(?=_(Normal|Watermark)Preview))/i, /https:\/\/tt\.se\/bild\/o\/[A-Za-z0-9-%_]*(sdl[A-Za-z0-9%_-]+)$/i].reduce((t, n) => t || e.match(n)?.[0], void 0);
}
function n(e) {
	try {
		return JSON.parse(e);
	} catch {
		return !1;
	}
}
//#endregion
export { e as parseImageId, n as parseJSON };
